export default __webpack_public_path__ + "static/media/arrow-left-line.bf6e4420.svg";